import { EEnableStatusType } from "../../Enum/EEnableStatusType"
import { EMoneyConditionType } from "../../Enum/EMoneyConditionType"
import { BaseModel } from "../Generics/BaseModel"

export class ExtraServiceEntity extends BaseModel {
  id: number

  name: string

  valueBase: number

  description: string

  isAutomatic: boolean

  status: EEnableStatusType

  conditionType: EMoneyConditionType

  iconUrl: string

  constructor(data: Partial<ExtraServiceEntity> = {}) {
    super()

    this.id = data.id ?? -1

    this.name = data.name ?? ""

    this.description = data.description ?? ""

    this.iconUrl = data.iconUrl ?? ""

    this.conditionType = data.conditionType ?? EMoneyConditionType.FixedValue

    this.status = data.status ?? EEnableStatusType.Active

    this.valueBase = data.valueBase ?? 0

    this.isAutomatic = data.isAutomatic ?? false
  }

  getAddValue(coast?: number) {
    if (this.valueBase <= 0) return 0

    if (this.conditionType === EMoneyConditionType.FixedValue || !coast) return this.valueBase

    return (this.valueBase / 100) * coast
  }
}
